import styled from "styled-components";

export const Container = styled.div`
    width: 100%;
    padding: 20px;
    background-color: ${({ theme }) => theme.colors.white};
`;